


$(document).on("scroll", function () {
  var pageTop = $(document).scrollTop();
  var pageBottom = pageTop + $(window).height();
  var tags = $(".fadein");

  for (var i = 0; i < tags.length; i++) {
      var tag = tags[i];

      if ($(tag).offset().top < pageBottom) {
          $(tag).addClass("visible");
      } else {
          $(tag).removeClass("visible");
      }
  }
});


/////////////////////////// video abnner section start ///////////////////////
$(document).ready(function () {
  const tl = gsap.timeline();
  const videoBox = document.querySelector(".video-box");
  const content = document.querySelector(".content");

  tl.to(videoBox, {
    y: "-150%", //-50%
    duration: 2,//1.5
    ease: "power4.out",//"power2.out"
  })
    .to(videoBox, {
      width: "100vw", 
      height: "100vh",
      y: "0%",
      borderRadius: "0",
      duration: 2,//1.5
      ease: "power4.inOut",//"power2.inOut"
    })
    .to(
      ".hero",
      {
        backgroundColor: "#fff",
        duration: 0.8,
        ease: "power2.inOut",
      },
      "-=1.5"//-=1
    )
    .to(
      content,
      {
        opacity: 1,
        duration: 1,
        ease: "power2.out",
      },
      "-=0.5"
    )

    //for text animation  h1 and p
    .fromTo(
      content.querySelector("h1"),
      {
        y: "100%",
      },
      {
        y: "0%",
        duration: 1.7,
        // ease: 'cubic-bezier(1, 0, 0.3, 0.9)',
        ease: "power4.out",//"power2.out"
      },
      "-=1"
    )
    .fromTo(
      content.querySelector("p"),
      {
        y: "100%",
      },
      {
        y: "0%",
        duration: 1.7,
        // ease: 'cubic-bezier(1, 0, 0.3, 0.9)',
        ease: "power4.out",//"power2.out"
        delay: 0.6,
      },
      "-=1.5"
    );
});
/////////////////////////// video abnner section end ///////////////////////

/////////////////////////// vision section start ///////////////////////
$(document).ready(function () {

  // let xValue = $(window).width() >= 768 ? $(window).width() + 250 : $(window).width() + 100; // Adjust 100 as needed for mobile

  /* gsap.to(".airplane-image", {
    x: $(window).width() + 250,//300
    // x: xValue,
    scrollTrigger: {
      trigger: ".scroll-section",
      start: "top center",//top center
      end: "bottom top",
      scrub: true,
      // pin:true
    },
  });

  ScrollTrigger.create({
    trigger: ".scroll-section",
    start: "top center",
    end: "bottom top",
    scrub: true,
    onUpdate: (self) => {
      let progress = self.progress;

      if (progress >= 0.33) {
        $("#section1").addClass("active");
      } else {
        $("#section1").removeClass("active");
      }

      if (progress >= 0.66) {
        $("#section2").addClass("active");
      } else {
        $("#section2").removeClass("active");
      }
    },
  }); */

  gsap.registerPlugin(ScrollTrigger);

    // Animate the content div
   /*  gsap.to(".airplane-image", {
      scrollTrigger: {
        trigger: ".airplane-image",
        start: "top 80%",   
        end: "top 20%",     
        scrub: true         
      },
      x: "100vw",           
    }); */
    
    /* gsap.to(".zipper-section", {
      scrollTrigger: {
        trigger: ".zipper-section",
        //start: "top 0%+=-10px",
        start: "top top",
        //end: "bottom 53%+=50px",     
        end: "bottom 83%-=0px",     
        pin: true,
        pinSpacing: true,
        markers: true,
        scrub: 1,   
      },
      //x: "0.001vw",   
      x: "0vw",   
      onComplete: myFunction,       
      onStart: myFunctionStart,       
      onReverseComplete: myFunctionStart,       
      //x: "100vw",
    });
    gsap.to(".zipper-section", {opacity:1, backgroundColor:'#fff'});
    
    //gsap.to(".zipper-section .airplane-image", {opacity:0});

    function myFunctionStart(){
      $(".zipper-section .airplane-image").css("right","-100px");
    }
    
    function myFunction(){
      setTimeout(function() {
        $(".zipper-section .airplane-image").css("right","-400px");
      }, 900);
    } */

      gsap.to(".zipper-section", {
        scrollTrigger: {
          trigger: ".zipper-section",
          start: "top 0%+=100px",
          end: "bottom bottom", // End when the bottom of .zipper-section reaches the top of the viewport
          pin: true, // Keeps the .zipper-section pinned while scrolling
          pinSpacing: true, // Adds spacing after pinning to avoid overlap
          markers: false, // Debug markers (remove for production)
          scrub: true, // Smooth scrolling effect
        },
        x: "0vw", // Animates to 50% of the viewport width
        //ease: "power1.inOut", // Smooth easing
      });
      
      // Additional opacity and background color animation
      gsap.to(".zipper-section", {
        scrollTrigger: {
          trigger: ".zipper-section",
          start: "top bottom",
          end: "bottom bottom",
          scrub: 1,
        },
        opacity: 1,
        backgroundColor: "#fff",
         paddingTop:'-100px'
      });
      //gsap.to(".zipper-section", {opacity:1, backgroundColor:'#fff', paddingTop:'100px'});
      
      // Animate the airplane image
      gsap.to(".zipper-section .airplane-image", {
        scrollTrigger: {
          trigger: ".zipper-section",
          start: "top bottom",
          end: "bottom bottom",
          scrub: 1,
        },
        right: "-400px", // Move the airplane image to the right
        //ease: "power1.inOut",
      });
});

/////////////////////////// vision  section end ///////////////////////

// /////////////////////////// Integral-content section start ///////////////////////
$(document).ready(function () {
  const interval = 5000;
  const $boxes = $(".box");
  const $circles = $(".Integral-content .final-investment-circle");
  let currentIndex = 0;
  let clickBox = false;

  function updateCarousel() {
    $boxes.removeClass("expanded");
    $boxes.find(".content").css({ opacity: 0, visibility: "hidden" });

    const $currentBox = $boxes.eq(currentIndex);
    $currentBox.addClass("expanded");
    $currentBox.find(".content").css({ opacity: 1, visibility: "visible" });

    $circles.removeClass("active");
    $circles.eq(currentIndex).addClass("active");
  }

  // Handle image box click
  $boxes.on("click", function () {
    currentIndex = $boxes.index(this);
    updateCarousel();
    clickBox = true;
  });

  // Handle circle click
  $circles.on("click", function () {
    currentIndex = $circles.index(this);
    updateCarousel();
  });

  // Auto-slide every interval
  setInterval(function () {
    if (!clickBox) {
      currentIndex = (currentIndex + 1) % $boxes.length;
      updateCarousel();
    } else {
      clickBox = false;
    }
  }, interval);

  // Initial state
  updateCarousel();
});
// /////////////////////////// Integral-content section end ///////////////////////

// /////////////////////////// horizontal slider section start ///////////////////////
$(document).ready(function () {
  // Initialize the main testimonial slider
  var $testimonialSlider = $(".testimonial-slider");

  $testimonialSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',
    dots: true,
    arrows: false,
    fade: true,
    speed: 1000, //500
    cssEase: "ease",
    infinite: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear"
  });

  // Sync the left, center, and right sections when the main slider moves
  $testimonialSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var slides = slick.$slides;

      // Slide out the current slide's left and right content
      slides
        .eq(currentSlide)
        .find(".testimonial-content-slide-left")
        .css("transform", "translateX(-100%)")
        .css("opacity", "0");
      slides
        .eq(currentSlide)
        .find(".testimonial-content-slide-right")
        .css("transform", "translateX(100%)")
        .css("opacity", "0");
      slides
        .eq(currentSlide)
        .find(".testimonial-content-slide-center")
        .css("opacity", "0");

      // Bring in the new slide's left and right content
      slides
        .eq(nextSlide)
        .find(".testimonial-content-slide-left")
        .css("transform", "translateX(0)")
        .css("opacity", "1");
      slides
        .eq(nextSlide)
        .find(".testimonial-content-slide-right")
        .css("transform", "translateX(0)")
        .css("opacity", "1");
      slides
        .eq(nextSlide)
        .find(".testimonial-content-slide-center")
        .css("opacity", "1");
    }
  );

  // After the change, reset the transforms
  $testimonialSlider.on("afterChange", function (event, slick, currentSlide) {
    var slides = slick.$slides;
    slides
      .eq(currentSlide)
      .find(".testimonial-content-slide-left")
      .css("transform", "translateX(0)")
      .css("opacity", "1");
    slides
      .eq(currentSlide)
      .find(".testimonial-content-slide-right")
      .css("transform", "translateX(0)")
      .css("opacity", "1");
    slides
      .eq(currentSlide)
      .find(".testimonial-content-slide-center")
      .css("opacity", "1");
  });
});
// /////////////////////////// horizontal slider section end ///////////////////////
